'use strict';

import $ from 'jquery';
import 'magnific-popup';
import herovideo from './herovideo';

let video = {

  onPlayerReady: function (event) {
    event.target.playVideo();
  },
  parseVideo: function (url) {

    // - Supported YouTube URL formats:
    //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
    //   - http://youtu.be/My2FRPA3Gf8
    //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
    // - Supported Vimeo URL formats:
    //   - http://vimeo.com/25451551
    //   - http://player.vimeo.com/video/25451551
    // - Also supports relative URLs:
    //   - //player.vimeo.com/video/25451551

    if (!url) {
      return null;
    }

    let type;

    url.match(/(http:|https:|)\/\/(player\.|www\.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/);

    if (RegExp.$3.indexOf('youtu') > -1) {
      type = 'youtube';
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
      type = 'vimeo';
    }

    return {
      type: type,
      id: RegExp.$6
    };

  },
  addYouTubeOverlayLinks: function () {
    let debug = window.location.href.indexOf('dev=tt') > -1 ? true : false;

    // jQuery selectors for links to be excluded from video overlay links
    const excludeLinks = [
        '.multiVideo a', // links inside multiVideo element.
        '.yt-video-image a', // product page youtube images and links. they add player to the page.
        '.no-video-overlay', // possibility to prevent with this classname
        '.gallery-grid-item-thumbnail'
      ].join(','),
      $contentLinks = $('.content a').not(excludeLinks);

    let ytVideoLinks = [];

    // loop thru links in content area and search for links that point to youtube/vimeo
    $contentLinks.each(function () {
      const data = video.parseVideo($(this).attr('href'));
      if (data && data.type === 'youtube') {
        $(this).toggleClass('open-video-overlay', true);
        $(this).attr('data-type', data.type).attr('data-id', data.id);
        ytVideoLinks.push($(this));
      } else if (data && data.type === 'vimeo') {
        $(this).toggleClass('open-vimeo-overlay', true);
        $(this).attr('data-type', data.type).attr('data-id', data.id);
      }
    });

    // add YouTube iframe_api?
    const YT = window.YT;
    if (YT && YT.Player) {
      // use api
      if (debug) console.log('using yt iframe_api');
    }
    else if (ytVideoLinks.length) {
      // add api
      if (debug) console.log('adding yt iframe_api');
      let tag = document.createElement('script');
      tag.src = '//www.youtube.com/iframe_api';
      let firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      if (debug) console.log('yt iframe_api appended');
    }

    window.onYouTubeIframeAPIReady = function () {
      if (debug) console.log('onYouTubeIframeAPIReady');
      $(document.body).toggleClass('ytPlayerReady', true);
      if ($(document.body).hasClass('videoBtnClicked')) {
        $(document.body).toggleClass('videoBtnClicked', false);
      }
      // functions to overlay's image thumbnails (video buttons)
      $(document.body).on('click', 'a[data-video-id]', function (e) {
        e.preventDefault();
        window.player.loadVideoById($(this).attr('data-video-id'));
      });
    };

    if (debug) console.log('ytVideoLinks', ytVideoLinks);

    // add magnific popup to yt-links
    $(ytVideoLinks).each(function () {
      if (debug) console.log('video.initVideo', video.initVideo);
      video.initVideo(this);
    });

    // add magnific popup to vimeo links
    if ($('.open-vimeo-overlay').length) {
      // NOTE: had to add IF-clause here for ('.open-vimeo-overlay').length
      // Without it magnific-popup creates JS error if page has no $('.open-vimeo-overlay') elements!
      $('.open-vimeo-overlay').magnificPopup({
        type: 'iframe',
        mainClass: 'multivideo-overlay',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: true,
        iframe: {
          patterns: {
            vimeo: {
              index: 'vimeo.com/',
              id: function (url) {
                let m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
                if (!m || !m[5]) return null;
                return m[5];
              },
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            }
          }
        }
      });
    }

    return false;

  },
  initVideo: function (btn) {

    let content = '<div class="multivideo-overlay-container">' +
      '<div class="multivideo-overlay-video-wrap">' +
      '<div id="multivideo-overlay-video"></div>' +
      '</div>' +
      '</div>';

    console.log('initVideo()');

    btn.magnificPopup({
      type: 'iframe',
      mainClass: 'multivideo-overlay',
      removalDelay: 0,
      preloader: false,
      fixedContentPos: true,
      disableOn: function () {
        // this function chooses if the popup should open or not
        if (!$(document.body).hasClass('ytPlayerReady')) {
          console.log('disabled');
          return false;
        }
        console.log('enabled');
        return true;
      },
      callbacks: {
        beforeOpen: function () {
          // open-or-not check moved to disableOn ^^^
        },
        open: function () {
          let YT = window.YT;
          window.player = new YT.Player('multivideo-overlay-video', {
            height: '315',
            width: '560',
            videoId: btn.attr('data-id'),
            playerVars: { rel: 0 },
            events: {
              'onStateChange': function (event) {
                if (event.data === 0 && btn.attr('data-video-close') === '1') { // event.data 0 == ENDED
                  $.magnificPopup.close();
                }
              },
              'onReady': video.onPlayerReady
            }
          });
        }
      },
      items: {
        src: content,
        type: 'inline' // this overrides default type
      }
    });

  },
  addVideoElement: function(element) {
    const iframe = element.querySelector('iframe');
    const video = element.querySelector('video');
    const overlay = element.querySelector('[data-video-element-overlay]');

    const removeOverlay = () => {
      overlay.remove();
      video?.removeEventListener('play', removeOverlay);
    };
    video?.addEventListener('play', removeOverlay);

    if ((iframe || video) && overlay) {
      const playVideo = () => {
        if (iframe) {
          if (!iframe.src) {
            iframe.src = iframe.dataset.src;
            iframe.focus();
            overlay.remove();
          }
        }
        else if (video) {
          video.play();
          video.focus();
        }
      };

      overlay.addEventListener('click', playVideo);
    }
  },

  addBlockVideoEvents: function(element) {
    const video = element.querySelector('video');
    const control = element.querySelector('.block-video-controls-play');

    const onPlay = (event => {
      if (control && event.type === 'play') {
        control.style.display = 'none';
      }
      if (control && event.type === 'pause') {
        control.style.display = 'block'
      }
    });

    video.addEventListener('play', onPlay);
    video.addEventListener('pause', onPlay);
  },
  init: function () {
    console.log('video.init()');
    this.addYouTubeOverlayLinks();
    herovideo.init();

    document.querySelectorAll('[data-video-element]').forEach(video => {
      this.addVideoElement(video);
    });

    document.querySelectorAll('.block-video-controls').forEach(video => {
      this.addBlockVideoEvents(video);
    })
  }
};

export default video;
